import { render } from "./MobileMenuChildrenComponent.vue?vue&type=template&id=16077cb4"
import script from "./MobileMenuChildrenComponent.vue?vue&type=script&lang=js"
export * from "./MobileMenuChildrenComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/frontend/components/MobileMenuChildrenComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "16077cb4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('16077cb4', __exports__)) {
    api.reload('16077cb4', __exports__)
  }
  
  module.hot.accept("./MobileMenuChildrenComponent.vue?vue&type=template&id=16077cb4", () => {
    api.rerender('16077cb4', render)
  })

}


export default __exports__